import { Component, Prop, Vue } from 'vue-property-decorator'
import { KTable } from '@kwixeo/table-vue'

@Component({
  components: {
    KTable
  }
})
export default class CustomersWithoutSales extends Vue {
  @Prop({ required: true }) type!: string
  @Prop({ required: true }) id!: number

  get ajaxUrl (): string {
    return '/catalog/' + this.type + '/' + this.id + '/customers-without-sales'
  }

  get columns (): KwixeoTable.Columns {
    return [
      {
        data: 'reference',
        name: this.$t('catalog.statistics.tables.reference'),
        width: 300,
        render: (references: KwixeoTable.Object) => {
          return references.customer ?? references.prospect
        }
      },
      {
        data: 'name',
        sortableName: 'customer.name',
        name: this.$t('catalog.statistics.tables.name')
      }
    ]
  }

  get filters (): KwixeoTable.FiltersOption {
    return [
      {
        type: 'period',
        label: this.$t('catalog.statistics.tables.period'),
        name: 'since',
        name2: 'until'
      }
    ]
  }
}
